var bodyPage = document.querySelector('body');
if (bodyPage.classList.contains('pghome')) {
    gsap.registerPlugin(ScrollTrigger);
    $(function() {
        // Init Variables
        const sectionOneTime = new Date('December 17, 1995 13:27:00'),
            minuteHand = document.getElementById("minuteHand"),
            hourHand = document.getElementById("hourHand");
        let now = sectionOneTime;

        // Init Clock Hands Rotation - 13:27
        gsap.set(minuteHand, {
            rotation: dataObj(now).minutes * 6
        });
        gsap.set(hourHand, {
            rotation: dataObj(now).hours * 30
        });
        
        // - Pure Positioning Triggers (no time change)
        ScrollTrigger.create({
            trigger: '#sectionOne',
            start: "top",
            onEnterBack: function() {
                document.getElementsByClassName('clock-container')[0].style.position = 'static';
            }//,
            //id: 'hero',
            //markers: true
        });

        ScrollTrigger.create({
            trigger: '#fixer',
            start: "-50px 0",
            onEnter: function() {
                document.getElementsByClassName('clock-container')[0].style.position = 'fixed';
            }//,
            //id: 's-fixer',
            //markers: true
        });

        // - Trigger from 13:27 to to 15:00
        ScrollTrigger.create({
            trigger: '#sectionTwo',
            start: 'top 200px',
            end: '+=200',
            onEnter: function () {
                now = new Date('December 17, 1995 13:27:00');
                rotateHands(0, 0);
                fadeInClock();
            },
            onEnterBack: function () {
                now = new Date('December 17, 1995 13:57:00');
                fadeInClock();
                rotateHands(-30, 2);
            },
            onLeave: function () {
                rotateHands(30, 2);
                fadeOutClock();
            }
            //id: 's-2',
            //markers: true
        });
        // - Trigger from 15:00 to 19:15
        ScrollTrigger.create({
            trigger: '#sectionThree',
            start: 'top 200px',
            end: '+=200',
            onEnter: function () {
                now = new Date('December 17, 1995 14:30:00');
                rotateHands(0, 0);
                fadeInClock();
                rotateHands(30, 2);
            },
            onEnterBack: function () {
                now = new Date('December 17, 1995 15:30:00');
                fadeInClock();
                rotateHands(-30, 2);
            },
            onLeave: function () {
                rotateHands(30, 2);
                fadeOutClock();
            },
            onLeaveBack: function () {
                rotateHands(-30, 2);
                fadeOutClock();
            }
            //id: 's-3',
            //markers: true
        });
        // - Trigger from 19:15 to 22:00
        ScrollTrigger.create({
            trigger: '#sectionFour',
            start: 'top 200px',
            end: '+=200',
            onEnter: function () {
                now = new Date('December 17, 1995 18:45:00');
                rotateHands(0, 0);
                fadeInClock();
                rotateHands(30, 2);
            },
            onEnterBack: function () {
                now = new Date('December 17, 1995 19:45:00');
                fadeInClock();
                rotateHands(-30, 2);
            },
            onLeave: function () {
                rotateHands(30, 2);
                fadeOutClock();
            },
            onLeaveBack: function () {
                rotateHands(-30, 2);
                fadeOutClock();
            }
            //id: 's-4',
            //markers: true
        });
        // - Trigger from 22:00 tp 23:00
        ScrollTrigger.create({
            trigger: '#sectionFive',
            start: 'top 200px',
            end: '+=200',
            onEnter: function () {
                now = new Date('December 17, 1995 21:30:00');
                rotateHands(0, 0);
                fadeInClock();
                rotateHands(30, 2);
            },
            onEnterBack: function () {
                now = new Date('December 17, 1995 22:30:00');
                fadeInClock();
                rotateHands(-30, 2);
            },
            onLeave: function () {
                rotateHands(30, 2);
                fadeOutClock();
            },
            onLeaveBack: function () {
                rotateHands(-30, 2);
                fadeOutClock();
            }
            //id: 's-5',
            //markers: true
        });
        // - Trigger + Fade from 23:00 to (arbitrary)
        ScrollTrigger.create({
            trigger: '#sectionSix',
            start: 'top 200px',
            end: '+=200',
            onEnter: function () {
                now = new Date('December 17, 1995 22:30:00');
                rotateHands(0, 0);
                fadeInClock();
                rotateHands(30, 2);
            },
            onEnterBack: function () {
                now = new Date('December 17, 1995 23:30:00');
                fadeInClock();
                rotateHands(-30, 2);
            },
            onLeave: function () {
                rotateHands(30, 2);
                fadeOutClock();
            },
            onLeaveBack: function () {
                rotateHands(-30, 2);
                fadeOutClock();
            }
            //id: 's-6',
            //markers: true
        });

        // Functions
        function dataObj(now) {
            const startTime = new Date('December 17, 1995 00:00:00');
            function convertMilliseconds(milliseconds) {
                var seconds = (milliseconds / 1000);
                var minutes = (seconds / 60);
                var hours = ((minutes / 60) % 12);
                return {
                seconds: seconds,
                minutes: minutes,
                hours: hours
                };
            };
            return convertMilliseconds(now - startTime);
        }
        function rotateHands(increment, duration) {
            now.setMinutes(now.getMinutes() + increment);
            gsap.to(minuteHand, {
                rotation: dataObj(now).minutes * 6,
                duration: duration
            });
            gsap.to(hourHand, {
                rotation: dataObj(now).hours * 30,
                duration: duration
            });
        }
        function fadeInClock() {
            document.getElementById('clock').classList.remove('fadeOut');
            document.getElementById('clock').classList.add('fadeIn');
        }
        function fadeOutClock() {
            document.getElementById('clock').classList.remove('fadeIn');
            document.getElementById('clock').classList.add('fadeOut');
        }
    });
}